import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'
import _imports_1 from '@/assets/images/avatar.png'
import _imports_2 from '@/assets/images/down.png'
import _imports_3 from '@/assets/images/quit.png'


const _withScopeId = n => (_pushScopeId("data-v-bf0300d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  target: "_blank",
  class: "login-img",
  style: {"width":"199px"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "hd-right-ul"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { href: "javascript:void(0)" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { href: "javascript:void(0)" }
const _hoisted_9 = { class: "hd-right-left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-div" }, null, -1))
const _hoisted_11 = { class: "hd-right-dropdown" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: "",
  width: "35",
  style: {"height":"35px","border-radius":"50%"}
}
const _hoisted_14 = { style: {"margin":"0 5px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  width: "15"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本资料", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改密码", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的地址", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  width: "15",
  style: {"margin-right":"2px"}
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 退出 ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

import HeaderSelect from "@/components/HeaderSelect/index.vue";
import PersonalInfoModel from "@/components/PersonalInfoModel/index.vue"
import { reactive, ref,onMounted,onBeforeUnmount } from "vue";
import {
  channel,
  checkOldPassword,
  editPassword,
  getPasswordParameters,
  OrderInProgressList,
} from "@/api/api";
import { FormInstance, message, Modal } from "ant-design-vue";
import { passwordValidate } from "@/utils/tool";
import { RuleObject } from "ant-design-vue/lib/form";
import { OUT_LOGIN } from "@/store/types";
import md5 from "js-md5";
import { useStore } from "vuex";
import router from "@/router";
type Form = {
  oldPassword: string;
  password: string;
  psd: string;
};
interface Data {
  dataList: any[];
  tabHoverId: string;
  visible: boolean;
  confirmLoading: boolean;
  form: Form;
  code: string;
  uuid: string;
  receiveTotal: number;
  progressTotal: number
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const formRef = ref<FormInstance>();
const showMobileMenu = ref(false)
const showMobileIcon = ref(false)
const menuContainerRef = ref()
const data: Data = reactive<Data>({
  dataList: [],
  tabHoverId: "",
  visible: false,
  confirmLoading: false,
  code: "",
  uuid: "",
  form: {
    oldPassword: "",
    password: "",
    psd: "",
  },
  receiveTotal: 0,
  progressTotal: 0
});
const toggleMobileMenu=()=> {
    showMobileMenu.value = !showMobileMenu.value;
  }
const checkScreenSize = () => {
  showMobileIcon.value = window.innerWidth < 900;
}
const handleDocumentClick = (event) => {
  // 检查点击是否发生在菜单容器外部
  if (
    showMobileMenu.value &&
    menuContainerRef.value &&
    !menuContainerRef.value.contains(event.target)
  ) {
    showMobileMenu.value = false;
  }
  mouseleaveTab()
}
onMounted(() => {
  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);
  document.addEventListener('click', handleDocumentClick);

})
onBeforeUnmount(() => {
  window.removeEventListener('resize', checkScreenSize);
  document.removeEventListener('click', handleDocumentClick);
})
channel().then((res: any) => {
  data.dataList = res.list.filter((item: { id: number }) => item.id !== 23);
});

// 移入到tab中
const mouseenterTab = (id: string) => {
  data.tabHoverId = id;
};
const clickTab = (id: string) => {
  if(data.tabHoverId === id) return data.tabHoverId = "";
  data.tabHoverId = id;
}
const mouseleaveTab = () => {
  data.tabHoverId = "";
};
// 获取进行中数量
// OrderInProgressList().then((res: any) => {
//   data.progressTotal = res.total_count
// })
// 点击基本资料
const personalInfoRef = ref();
function clickInfo() {
  personalInfoRef.value.visibleInfo = true
}

// 密码检验规则
const psdValidate = (rule: RuleObject, value: string) => {
  if (value === "") {
    return Promise.reject("请输入密码");
  }
  if (value === data.form.password) {
    return Promise.resolve();
  }
  return Promise.reject("与新密码不一致");
};
const rules = {
  oldPassword: [
    { required: true, validator: passwordValidate, trigger: "blur" },
  ],
  password: [{ validator: passwordValidate, trigger: "blur" }],
  psd: [{ validator: psdValidate, trigger: "blur" }],
};
// 点击修改密码
function clickEditPassword() {
  data.visible = true;
  getPsdParameters();
}
//点击我的地址
function clickMyAddress(){
  router.push("/address/List");
}
// 获取加密方式
function getPsdParameters() {
  getPasswordParameters().then((res: any) => {
    data.code = res.code;
    data.uuid = res.uuid;
  });
}
// 点击弹窗确定
function handleOk(type?: string) {
  if (type === "password") {
    // 修改密码弹窗
    formRef.value?.validate().then(() => {
      data.confirmLoading = true;
      // 先验证旧密码是否正确
      const oldPassword = md5(
        md5(
          md5(data.form.oldPassword) +
          data.code +
          md5(data.form.oldPassword)
        ) + data.uuid
      );
      checkOldPassword({
        old_password: oldPassword,
      })
        .then(() => {
          editPassword({
            password: md5(data.form.password),
          })
            .then(() => {
              message.success("更新密码成功");
              location.replace("/login");
              formRef.value?.resetFields();
              data.confirmLoading = false;
              data.visible = false;
            })
            .catch(() => {
              getPsdParameters();
              data.confirmLoading = false;
            });
        })
        .catch(() => {
          getPsdParameters();
          data.confirmLoading = false;
        });
    });
  }
}
// 弹框关闭
function handleCancel(type?: string) {
  if (type === "password") {
    formRef.value?.resetFields();
  }
}
// 点击退出登录
function clickLogout() {
  Modal.confirm({
    title: "即将退出登录，是否继续？",
    closable: true,
    onOk() {
      store.commit(OUT_LOGIN);
      location.replace("/");
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_AlignRightOutlined = _resolveComponent("AlignRightOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["hd-right", {
       'hd-right-icon': showMobileIcon.value,
       'justify-end': showMobileIcon.value && !showMobileMenu.value,
       'align-start': showMobileIcon.value && showMobileMenu.value
     }]),
        ref: (_value, _refs) => {
          _refs['menuContainerRef'] = _value
          menuContainerRef.value = _value
        }
      }, [
        (showMobileIcon.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "hamburger-icon",
              onClick: _withModifiers(toggleMobileMenu, ["stop"])
            }, [
              _createVNode(_component_AlignRightOutlined)
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (!showMobileIcon.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).dataList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  onClick: _withModifiers(($event: any) => (clickTab(String(item.id))), ["stop"])
                }, [
                  _createElementVNode("a", _hoisted_6, _toDisplayString(item.channel_name), 1),
                  (_unref(data).tabHoverId == String(item.id))
                    ? (_openBlock(), _createBlock(HeaderSelect, {
                        key: 0,
                        items: item,
                        type: item.id
                      }, null, 8, ["items", "type"]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (showMobileMenu.value)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 2,
              class: _normalizeClass(["hd-right-ul", { 'mobile-menu': showMobileMenu.value }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).dataList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  onClick: _withModifiers(($event: any) => (clickTab(String(item.id))), ["stop"])
                }, [
                  _createElementVNode("a", _hoisted_8, _toDisplayString(item.channel_name), 1),
                  (_unref(data).tabHoverId == String(item.id))
                    ? (_openBlock(), _createBlock(HeaderSelect, {
                        key: 0,
                        items: item,
                        type: item.id
                      }, null, 8, ["items", "type"]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7))
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_a_dropdown, { placement: "bottomRight" }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { style: {"background":"#f5f5f5","cursor":"default"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$store.state.userInfo.email), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$store.state.userInfo.company), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { onClick: clickInfo }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { onClick: clickEditPassword }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { onClick: clickMyAddress }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "hd-right-user",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  (_ctx.$store.state.userInfo.head_image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.$store.state.userInfo.head_image,
                        alt: "",
                        width: "35",
                        style: {"height":"35px","border-radius":"50%"}
                      }, null, 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("img", _hoisted_13)),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$store.state.userInfo.fullname), 1),
                  _hoisted_15
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "quit",
            onClick: clickLogout
          }, _hoisted_21)
        ])
      ], 2)
    ]),
    _createVNode(_component_a_modal, {
      visible: _unref(data).visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_unref(data).visible = $event)),
      title: "更新密码",
      "confirm-loading": _unref(data).confirmLoading,
      destroyOnClose: true,
      maskClosable: false,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (handleCancel('password'))),
      onOk: _cache[6] || (_cache[6] = ($event: any) => (handleOk('password')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          model: _unref(data).form,
          "label-col": { span: 4 },
          autocomplete: "off",
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "原密码",
              name: "oldPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _unref(data).form.oldPassword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_unref(data).form.oldPassword = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "新密码",
              name: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _unref(data).form.password,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_unref(data).form.password = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "确认密码",
              name: "psd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _unref(data).form.psd,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_unref(data).form.psd = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"]),
    _createVNode(PersonalInfoModel, {
      ref: (_value, _refs) => {
        _refs['personalInfoRef'] = _value
        personalInfoRef.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})